<template>
  <div class="page-left">
    <div>{{$t('guild-GuildComponents-Head11') || '我的公会'}}</div>
    <div>{{$t('Layout-SiderNav1') || '我的任务'}}</div>
    <div>{{$t('guild-Tag-tagDetail29') || '练习与勋章'}}</div>
    <div>{{$t('Layout-SiderNav3') || '我的积分'}}</div>
  </div>
</template>

<script>
import {routePathData} from 'assets/scripts/common';

export default {
  computed: {
  },
  watch: {
    $route (to, from) {
      this.currentPath = to.path;
    }
  },

  data () {
    return {
      modeType: 0,
      routePathData,
      currentPath: '',
      activeName: null,
      openNames: [],
      altasManageMenu: [], // 图谱管理
      datasManageMenu: [], // 数据管理
      singleAltasMenu: {}, // 单个图谱菜单
      subscribeMenu: {}, // 订阅菜单
      subscribeSubMenus: [], // 订阅子菜单
      isSubscribe: true,
      ceptName2: ''
    };
  },

  methods: {

  },

  mounted () {
    this.currentPath = this.$route.path;
  }
};
</script>

<style rel="stylesheet/less" lang="less" scoped>
  @import "../../assets/theme/themeBlue.less";

  .page-left {
    background: #DDA0DD;
    line-height: 40px;
    width: 200px;
    float: left;
    text-align: center;
  }
</style>
